import { AppBar, ButtonBase, Dialog, IconButton, Menu, MenuItem, Toolbar } from "@material-ui/core";
import { FC, HTMLAttributes, memo, ReactElement, ReactNode, useEffect, useState } from "react";
import { changeDirection } from "../../libs/persian";
import { clearAllPopups, goBackPopup } from "../../libs/services";
import { areEqual, parseMessage } from "../../libs/utils";
import styles from "./popups.module.scss";

type ToolbarDialogProps = {
  title?: string;
  children?: ReactNode;
  menuItems?: {
    title: string;
    action: (...keys: any) => void;
  }[];
  menuItem?: () => ReactElement;
  backFunc?: () => void;
  onBackdropClick?: () => void;
  fullScreen?: boolean;
  dontShowToolbar?: boolean;
  dontShowBackBtn?: boolean;
};

export const ToolbarDialog: FC<ToolbarDialogProps> = memo((props) => {
  const [localeAnchorEl, setLocaleAnchorEl] = useState<HTMLElement | null>(null);

  const handleOptionsDropdown = (anchorEl: HTMLElement | null): void => {
    setLocaleAnchorEl(anchorEl);
  };

  const backFunc = props.backFunc !== undefined ? props.backFunc : goBackPopup;
  return (
    <Dialog
      open={true}
      fullScreen={props.fullScreen}
      // onClose={backFunc}
      fullWidth={true}
      maxWidth="xs"
      onBackdropClick={() => {
        if (props.onBackdropClick) {
          // @ts-ignore
          props.onBackdropClick();
        }

        clearAllPopups();
      }}
    >
      <AppBar className="position-relative shadow" dir="ltr">
        {!props.dontShowToolbar && (
          <Toolbar className={styles.toolbar}>
            {!props.dontShowBackBtn && (
              <IconButton onClick={backFunc} className="text-white">
                <i className="icon-back" />
              </IconButton>
            )}
            {props.title && <span className={`font-size-body col text-center ${styles.title} py-1`}>{props.title}</span>}
            {props.menuItems !== undefined && (
              <IconButton className="text-white" onClick={(e) => handleOptionsDropdown(e.currentTarget)}>
                <i className="icon-other" />
              </IconButton>
            )}
            {props.menuItem !== undefined && <props.menuItem />}
            {(props.menuItems === props.menuItem) === undefined && <div className={`${styles.empty_box}`} />}
            <Menu anchorEl={localeAnchorEl} open={localeAnchorEl !== null} onClose={() => handleOptionsDropdown(null)}>
              {props.menuItems?.map((item, i) => (
                <MenuItem onClick={item.action} key={i}>
                  {item.title}
                </MenuItem>
              ))}
            </Menu>
          </Toolbar>
        )}
      </AppBar>
      <div className={`py-3 ${props.fullScreen ? styles.fullHeghitToolbar : styles.scroll_container}`}>{props.children}</div>
    </Dialog>
  );
}, areEqual);

type PopupContainerProps = {
  children: ReactNode;
  title?: string;
  className?: HTMLAttributes<HTMLSpanElement>["className"];
};

export const PopupContainer: FC<PopupContainerProps> = memo((props) => {
  return (
    <div className={`${styles.container} ${props.className}`}>
      {props.title !== undefined && props.title.length > 0 && <span className={styles.title}>{props.title}</span>}
      {props.children}
    </div>
  );
}, areEqual);

type PopupListProps = {
  title?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  onClick?: () => void;
  className?: HTMLAttributes<HTMLSpanElement>["className"];
  disabled?: boolean;
  underText?: string;
  children?: ReactNode;
  dataTestId?: string;
};

export const PopupList: FC<PopupListProps> = memo((props) => {
  useEffect(() => changeDirection(`.${styles.content}`), [props.title]);

  return (
    <div className={styles.list_wrapper}>
      {props.children ? (
        <ButtonBase className={styles.list}>{props.children}</ButtonBase>
      ) : (
        <ButtonBase data-testid={props.dataTestId} className={styles.list} onClick={props.onClick} disabled={props.disabled}>
          {props.startIcon !== undefined && <div className={styles.start_icon}>{props.startIcon}</div>}
          <span className={`parsed_html ${styles.content} ${props.className}`} dangerouslySetInnerHTML={{ __html: parseMessage(props.title, { parseLinks: false }) }} />
          {props.endIcon !== undefined && <div className={styles.end_icon}>{props.endIcon}</div>}
        </ButtonBase>
      )}
      {props.underText !== undefined && (
        <div className="px-3 my-1">
          <span className="mx-2 text-justify font-size-caption">{props.underText}</span>
        </div>
      )}
    </div>
  );
}, areEqual);
